import React from 'react';
import { Typography } from "@mui/material";
import useStyles from "../../style/js-style/components/common/InfoBloc";
import EAAlertIcon from './EAAlertIcon';
import { ERROR, INFO, SUCCESS, WARNING } from 'services/common/Constants';

const getColorDependingOnSeverity = (severity) => {
  switch (severity) {
    case ERROR:
      return { background: "#FFEBEB", titleColor: "#990001", textColor: "#990001" };
    case SUCCESS:
      return { background: "#F6F9F3", titleColor: "#32614F", textColor: "#32614F" };
    case WARNING:
      return { background: "#FFF7EB", titleColor: "#995C00", textColor: "#CC7B00" };
    case INFO:
    default:
      return { background: "#F2F3F7", titleColor: "#2E2E3A", textColor: "#2E2E3A" };
  }
};

const InfoBloc = ({
  title,
  text,
  severity
}) => {
  const { classes } = useStyles();

  const divColors = getColorDependingOnSeverity(severity);

  return (
    <div style={{ backgroundColor: divColors.background }} className={classes.layout}>
      <div style={{ display: "flex" }}>
        <EAAlertIcon severity={severity} className={classes.icon} />
        <Typography className={classes.title} style={{ color: divColors.titleColor }}>{title}</Typography>
      </div>
      <div className={classes.text} style={{ color: divColors.textColor }}>
        {text}
      </div>
    </div>
  );
};
export default InfoBloc;
